// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
import styled from 'styled-components';
import { Link } from '@helpcenter/analytics-components/src/link';
import * as fonts from '@helpcenter/styles/src/fonts';
import * as mixins from '@helpcenter/styles/src/mixins';
import { IconCardLayout } from 'view/layout/icon-card-layout';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { token } from '@atlaskit/tokens';

const HC_ADS_DROP_COMMIT_2 = 'hc_ads_drop_commit_2';
const isHcAdsDropCommit2Enabled = (): boolean => FeatureGates.checkGate(HC_ADS_DROP_COMMIT_2);

export type ContainerPadding = 'tight' | 'default';

interface StyledIconCardLayoutProps {
	containerPadding?: ContainerPadding;
}

interface StyledLinkProps {
	selected: boolean;
}

const GROUP_BOX_PADDING_LEFT_RIGHT_TIGHT = token('space.200', '16px');
export const GROUP_BOX_PADDING_LEFT_RIGHT = token('space.300', '24px');
export const GROUP_BOX_PADDING_TOP_BOTTOM = token('space.300', '24px');

// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const StyledIconCardLayout = styled(IconCardLayout)<StyledIconCardLayoutProps>`
	/* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
	padding: ${GROUP_BOX_PADDING_TOP_BOTTOM}
		${(props) =>
			props.containerPadding === 'tight'
				? GROUP_BOX_PADDING_LEFT_RIGHT_TIGHT
				: GROUP_BOX_PADDING_LEFT_RIGHT};
`;

// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const Heading = styled.div<{ lineClamp: boolean }>`
	${fonts.h400};
	${(props) => mixins.applyIf(props.lineClamp, mixins.clamp)};
	color: ${(props) => token('color.text.brand', props.theme.color)};
	margin: 0;
`;

// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const HeadingContent = styled.div<{ lineClamp: boolean }>`
	${(props) => mixins.applyIf(props.lineClamp, mixins.clamp)};
	color: ${(props) => token('color.text.brand', props.theme.color)};
	margin: 0;
`;
// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const Description = styled.div<{ lineClamp: number }>`
	${(props) =>
		mixins.applyIf(
			props.lineClamp > 0,
			/*
                We use multiline clamp so we avoid descriptions that have multi paragraphs looking like this:
                Clamped...
                Clamped...
                Clamped...
            */
			mixins.multiLineClamp(props.lineClamp),
		)};
	color: ${token('color.text', '#172B4D')};
	margin-top: ${token('space.050', '4px')};
`;

// eslint-disable-next-line rulesdir/no-styled-export, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- Disabled to rollout go/ui-styling-standard tooling, please resolve
export const StyledLink = styled(Link)<StyledLinkProps>`
	${mixins.borderRadius};
	${() => isHcAdsDropCommit2Enabled() && mixins.borderRadiusLarge}
	display: block;
	/* stylelint-disable-next-line scale-unlimited/declaration-strict-value */
	background-color: ${(props) =>
		props.selected ? token('elevation.surface.raised', '#F4F5F7') : 'inherit'};

	&:hover,
	&:focus-visible {
		text-decoration: none;
		background-color: ${token('elevation.surface.raised.hovered', '#F4F5F7')};
	}

	&:hover [data-edit-overlay] {
		opacity: 1;
	}

	&:focus {
		text-decoration: none;
	}
`;
